import { render, staticRenderFns } from "./BankReturnOverview.vue?vue&type=template&id=1b497fe0"
import script from "./BankReturnOverview.vue?vue&type=script&lang=js"
export * from "./BankReturnOverview.vue?vue&type=script&lang=js"
import style0 from "./BankReturnOverview.vue?vue&type=style&index=0&id=1b497fe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports